import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3ea2c7fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-page-layout" }

import InnerPageLayout from "@/widgets/layouts/InnerPageLayout.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemsWithTableLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnerPageLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "body")
      ])
    ]),
    _: 3
  }))
}
}

})